<template>
  <div id="modal" class="modal modal__recommended-orgs modal-auto-height" role="dialog">
    <button
      type="button"
      class="btn-close"
      @click="close"
      aria-label="Close modal"
      title="Close"
    >
      ×
    </button>

    <header class="modal-header">
      <h3 class="modal-header-title">Recommended Organisations</h3>
    </header>

		<template v-if="current_org">

			<section class="modal-body">
				<div class="org-cards__container">
					<block-org-card :payload="current_org" :class="{'fade':transition}"></block-org-card>
				</div>
				<div class="line line-grey my-6"></div>
			</section>

			<footer class="modal-footer">
				<div class="arrow-container">
					<button @click.prevent="prevOrg()" title="Previous Organisation" aria-label="Previous Organisation" :disabled="hidePrev">
						<svg-chevron-left class="prev"></svg-chevron-left>
					</button>
				</div>

				<block-alert-button class="btn btn-border--blue btn-rounded btn-small" :org_main_id="current_org['org-main-id']" :org_name="current_org['org-name']" title="Create alert" aria-label="Create alert"></block-alert-button>

				<div class="arrow-container">
					<button @click.prevent="nextOrg()" title="Next Organisation" aria-label="Next Organisation" :disabled="hideNext">
						<svg-chevron-left class="next"></svg-chevron-left>
					</button>
				</div>
			</footer>
		</template>

  </div>
</template>

<script>
	import AuthMixins from '@/mixins/AuthMixins';
	import RecommendedOrgs from '@/mixins/RecommendedOrgs';

  export default {
    name: 'RecommendedOrgs',
    mixins: [AuthMixins,RecommendedOrgs],

    data() {
      return {
				current_org: false,
        display_index: 0,
        transition: false,
      }
    },

    mounted() {
			this.display_index = this.recommended_orgs.index;

			if (this.recommended_orgs !== null) {
				this.current_org = this.recommended_orgs.orgs[this.display_index];
			} else {
				this.current_org = false;
			}

      console.log('recommended_orgs:', this.recommended_orgs);
    },

    methods: {
      close() {
        this.$emit('close')
      },
      prevOrg() {
        if (this.display_index > 0) {
          this.doTransition(-1);
        }
      },
      nextOrg() {
        if (this.display_index < this.recommended_orgs.orgs.length -1) {
          this.doTransition(+1);
        }
      },
      doTransition(plusMinus) {
        this.transition = true;
        setTimeout(() => {
          this.transition = false;
          this.display_index = this.display_index + plusMinus;
        }, 300);
      }
    },

    computed: {
      hidePrev() {
        return this.display_index <= 0;
      },
      hideNext() {
        return this.display_index >= this.recommended_orgs.length - 1;
      },
    },
		watch: {
			display_index: {
				handler() {
					this.recommended_orgs.index = this.display_index;
					this.setRecommended(this.recommended_orgs);
					this.current_org = this.recommended_orgs.orgs[this.display_index];
				}
			}
		}
  };
</script>
